import React from 'react';

import { Translate } from 'react-redux-i18n';

import { TemplatePage } from '../../../../components/common/pager';
import { TemplateHeader } from '../../../../components/template/templateHeader';
import { TemplateCheckbox } from '../../../../components/template/templateCheckbox';
import { TemplateCurrency } from '../../../../components/template/templateCurrency';
import { TemplateTextArea } from '../../../../components/template/templateTextArea';
import { TemplateToggle } from '../../../../components/template/templateToggle';

import config from '../../../../constants';
import { paths } from '../constants/template';

export const getRegistrationFeeTab = (props: any) => {
  const { onChange, feeEnabled, currency, optional, required } = props;

  const validation = feeEnabled ? required : optional;
  const amountValidation = {
    ...validation,
    amount: true,
    minValue: config.REGISTRATION_FEE_MIN_AMOUNT
  };

  return (
    <TemplatePage
      id="registrationFee"
      path={paths.REGISTRATION_FEE_TAB}
      i18nKey="eventPrograms.template.page.registration-fee.title"
    >
      <TemplateHeader
        as="h2"
        label="eventPrograms.template.page.registration-fee.header"
      />

      <p>
        <Translate value="eventPrograms.template.page.registration-fee.subtext" />
      </p>

      <TemplateCheckbox
        id="enableRegistrationFee"
        path={paths.REGISTRATION_FEE_ENABLED}
        inputLabel="eventPrograms.template.page.registration-fee.checkbox"
        onChange={onChange}
      />

      <TemplateToggle path={paths.REGISTRATION_FEE_ENABLED}>
        <TemplateCurrency
          id="registrationFeeAmount"
          path={paths.REGISTRATION_FEE_AMOUNT}
          label="eventPrograms.template.page.registration-fee.amount.label"
          subtext="eventPrograms.template.page.registration-fee.amount.subtext"
          validation={amountValidation}
          currency={currency}
          allowDecimal
          onChange={onChange}
        />

        <TemplateTextArea
          id="registrationFeeTerms"
          path={paths.REGISTRATION_FEE_TERMS}
          label="eventPrograms.template.page.registration-fee.terms.label"
          placeholder="eventPrograms.template.page.registration-fee.terms.subtext"
          validation={validation}
          maxLength={config.REGISTRATION_FEE_TERMS_MAX_LENGTH}
          onChange={onChange}
        />

        <TemplateCheckbox
          id="registrationFeeNonRefundable"
          path={paths.REGISTRATION_FEE_NON_REFUNDABLE}
          inputLabel="eventPrograms.template.page.registration-fee.non-refundable"
          onChange={onChange}
        />
      </TemplateToggle>
    </TemplatePage>
  );
};
